import PropTypes from 'prop-types';
import {Component} from 'react';
import {withRouter} from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';

class ScrollToTop extends Component {
  static propTypes = {
    location: ReactRouterPropTypes.location.isRequired,
    children: PropTypes.element.isRequired,
  };

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);
